// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Test-module--wrap--3O0mO","container":"Test-module--container--1WjuJ","slider":"Test-module--slider--SiSSg","textWrap":"Test-module--textWrap--2dlwf"};